import styleInject from './../../__node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "._Es5ix{position:absolute;top:-10000px;left:-10000px}";
var classes = {"ariaLiveElement":"_Es5ix"};
var stylesheet="._Es5ix{position:absolute;top:-10000px;left:-10000px}";
if(typeof process !== 'object' || !process.hasOwnProperty('env') || process.env.NODE_ENV !== 'test'){styleInject(css_248z);}

export { classes as default, stylesheet };
